import Vue from 'vue'
import Router from 'vue-router'
import homeRouter from './home'


Vue.use(Router)

export const baseRouters = [
  ...homeRouter,
  {
    path: '/',
    // redirect: '/home'
  },{
    path: '*',
    redirect: '/404'
  },{
    path: '/404',
    component: () => import('@/page/error-page/404'),
  },
]
// 动态需要根据权限加载的路由表
// export const asyncRouterMap = [{
//     path: '/permission',
//     // name: 'permissionhome',
//     meta: {
//       title: 'permission',
//       icon: 'el-icon-setting',
//       roles: ['admin']
//     },
//     component: () => import('@/page/home'),

//     children: [{
//       name: 'permission',
//       path: '/permission',
//       meta: {
//         title: 'permission',
//         icon: 'el-icon-menu',
//         roles: ['admin']
//       },
//       component: () => import('@/page/home'),

//     }]
//   },
//   {
//     path: '*',
//     redirect: '/404',
//     hidden: true
//   }
// ]
const createRouter = () => new Router({
  mode: 'history', // require service support
  // scrollBehavior: () => ({
  //   y: 0
  // }),
  routes: baseRouters
})


const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

const router = createRouter()



export default router